/**
 * Shared sitemap utility functions
 */

/**
 * Normalize a string for matching by removing spaces, converting to lowercase
 */
export function normalizeName(name: string): string {
    return name.toLowerCase().replace(/\s+/g, '')
}

/**
 * Find a sitemap that matches the query parameter intelligently
 */
export function findSitemapByQuery(sitemaps: SitemapData[], queryValue: string): SitemapData | null {
    
    if (!queryValue || !sitemaps.length) {
        return null
    }
    
    const normalizedQuery = normalizeName(queryValue)
    
    // First try exact match on normalized names
    const exactMatch = sitemaps.find(sitemap => {
        const normalized = normalizeName(sitemap.name)
        const isMatch = normalized === normalizedQuery
        return isMatch
    })
    if (exactMatch) {
        return exactMatch
    }
    
    // Then try partial match (query contained in sitemap name)
    const partialMatch = sitemaps.find(sitemap => {
        const normalized = normalizeName(sitemap.name)
        const isMatch = normalized.includes(normalizedQuery)
        return isMatch
    })
    if (partialMatch) {
        return partialMatch
    }
    
    // Finally try reverse partial match (sitemap name contained in query)
    const reverseMatch = sitemaps.find(sitemap => {
        const normalized = normalizeName(sitemap.name)
        const isMatch = normalizedQuery.includes(normalized)
        return isMatch
    })
    if (reverseMatch) {
        return reverseMatch
    }
    
    return null
}

/**
 * Find a sitemap that contains the specified unit
 */
export function findSitemapContainingUnit(sitemaps: SitemapData[], unitName: string, app: AppData): SitemapData | null {
    if (!unitName || !sitemaps.length) {
        return null
    }
    
    // Find the unit by name
    const targetUnit = app.units.find(unit => unit.name === unitName)
    
    if (!targetUnit) {
        return null
    }
    
    // Find the first sitemap that contains this unit
    for (let i = 0; i < sitemaps.length; i++) {
        const sitemap = sitemaps[i]
        const hasUnit = sitemap.units.some(sitemapUnit => sitemapUnit.unitId === targetUnit.id)
        
        if (hasUnit) {
            return sitemap
        }
    }
    
    return null
}

/**
 * Get query parameter value from URL
 */
export function getQueryParameter(name: string): string | null {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(name)
}